export default __webpack_public_path__ + "static/media/project-bl.674d1afd.jpg";